import { FC, ReactNode, useId } from 'react';

import classnames from 'classnames';

import { useInputError } from '../../../_hooks';
import InputWrapper, { InputWrapperProps } from '../InputWrapper';
import './checkbox.scss';

export type InputCheckboxProps = InputWrapperProps & {
  checked?: boolean;
  children?: ReactNode;
  onChange: (checked: boolean, name: string, value?: string) => void;
  type?: 'checkbox' | 'radio' | 'toggle';
  value?: string;
};

const Checkbox: FC<InputCheckboxProps> = ({
  children,
  checked,
  onChange,
  type = 'checkbox',
  className,
  value,
  ...wrapperProps
}) => {
  const { disabled, validation, name } = wrapperProps;
  const { setDirty, showError } = useInputError(validation);
  const checkBoxId = useId();

  return (
    <InputWrapper
      className={classnames('checkbox-wrapper', className, { 'checkbox-toggle': type === 'toggle' })}
      id={checkBoxId}
      {...wrapperProps}
      showError={showError}
    >
      <label className={classnames({ 'is-error': showError })}>
        <input
          checked={checked}
          disabled={disabled}
          id={checkBoxId}
          name={wrapperProps.name}
          onChange={event => {
            onChange(event.currentTarget.checked, name, value);
            setDirty();
          }}
          type={type === 'toggle' ? 'checkbox' : type}
        />
        <span>{children}</span>
      </label>
    </InputWrapper>
  );
};

export default Checkbox;
